/**
 * 判断当前是否处于微信内置浏览器（含公众号、会话内打开等场景）。
 * @returns {boolean}
 */
export function isWeChatBrowser() {
  if (typeof navigator === 'undefined') return false;
  return /micromessenger/i.test(navigator.userAgent || '');
}
